module.exports = __webpack_public_path__ + "static/media/cloud1-blue-min.1c060ba5.png";